import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, KeyRound, Info } from "lucide-react";
import { toast } from "sonner";
import { api, setAuthToken } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";
import { pwError } from "./pwRules";

const IN = "input-ui mt-1";

export default function ChangePassword() {
  const [f, setF] = useState({ cur: "", pw: "", pw2: "" });
  const [busy, setBusy] = useState(false); const [err, setErr] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    const v = !f.cur ? "Isi password saat ini." : pwError(f.pw, f.pw2) || (f.pw === f.cur ? "Password baru harus berbeda dari password lama." : "");
    if (v) { setErr(v); return; }
    setBusy(true); setErr("");
    try {
      const r = await api.post("/auth/change-password", { current_password: f.cur, new_password: f.pw });
      if (r.data?.access_token) setAuthToken(r.data.access_token);
      setF({ cur: "", pw: "", pw2: "" }); toast.success("Password diubah. Perangkat lain sudah dikeluarkan.");
    } catch (e2) { setErr(apiErr(e2, "Gagal mengubah password")); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="aivora-card p-6" data-testid="change-password">
      <p className="flex items-center gap-2 text-sm font-bold text-slate-900"><KeyRound size={16} className="text-brand" /> Ubah password</p>
      <p className="mt-2 flex items-start gap-1.5 rounded-xl bg-amber-50 px-3 py-2 text-xs text-amber-800" data-testid="change-password-warning"><Info size={13} className="mt-0.5 shrink-0" /> Semua perangkat lain akan logout setelah password diubah. Perangkat ini tetap masuk.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        <label className="text-xs font-semibold text-slate-600">Password saat ini<input type="password" value={f.cur} onChange={set("cur")} autoComplete="current-password" className={IN} data-testid="cp-current" /></label>
        <label className="text-xs font-semibold text-slate-600">Password baru<input type="password" value={f.pw} onChange={set("pw")} autoComplete="new-password" placeholder="6–72 karakter" maxLength={72} className={IN} data-testid="cp-new" /></label>
        <label className="text-xs font-semibold text-slate-600">Ulangi password baru<input type="password" value={f.pw2} onChange={set("pw2")} autoComplete="new-password" className={IN} data-testid="cp-confirm" /></label>
      </div>
      {err && <p className="mt-3 text-xs font-semibold text-rose-600" data-testid="cp-error">{err}{/lama salah/i.test(err) && <> — akun Google? <Link to="/forgot-password" className="underline">Gunakan Lupa Password</Link></>}</p>}
      <div className="mt-4 flex justify-end">
        <button disabled={busy || !f.cur || !f.pw} className="btn-primary inline-flex items-center gap-1.5 rounded-xl px-4 py-2 text-xs font-bold disabled:opacity-50" data-testid="cp-submit">{busy && <Loader2 size={12} className="animate-spin" />} Simpan password</button>
      </div>
    </form>
  );
}
